<template>
  <div class="match-overall">
    <div ref="fixedHeader" style="position: fixed; top: 0; z-index: 999; background-color: #FFFFFF;">
      <div class="swipe">
        <van-swipe :autoplay="5000" :show-indicators="true">
          <van-swipe-item v-for="(image, index) in carousels" :key="index">
            <div @click="goUrl(image)">
              <van-image :src="imageView(image.poster)" width="100%" fit="cover" />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <van-tabs v-model="active" sticky @change="changeTab">
        <van-tab title="活动总览" :name="0"></van-tab>
        <van-tab title="新闻公告" :name="1"></van-tab>
        <van-tab title="赛程赛果" :name="2" v-if="sportType !== '综合类'"></van-tab>
        <van-tab title="参赛名单" :name="3" v-if="sportType !== '综合类'"></van-tab>
        <van-tab title="我的报名" :name="4"></van-tab>
        <van-tab title="我的付费" :name="5" v-if="isOpenCharge === 1"></van-tab>
      </van-tabs>
    </div>
    <div :style="{ height: fixedHeaderHeight + 'px' }"></div>
    <div v-if="active === 0">
      <div class="match-info">
        <div class="match-name">
          {{ match.chineseName }}
        </div>
        <div class="time-place">
          <div class="row">
            <img src="../../assets/date.png" style="width: 16px; height: 16px;">
            <div style="margin-left: 4px">{{ getFormatDate(match.beginDate) }} ~ {{ getFormatDate(match.endDate) }}</div>
          </div>
          <div class="row" style="margin-top: 4px;">
            <img src="../../assets/position.png" style="width: 16px; height: 16px;">
            <div
              style="margin-left: 4px; overflow:hidden; white-space: nowrap; text-overflow: ellipsis; -o-text-overflow:ellipsis;">
              {{ place.join('-') }}
            </div>
          </div>
        </div>
      </div>
      <div class="status">
        <div class="point">
          <div class="desc">
            <div class="info" :class="status[0]">筹备中</div>
            <div class="icon" :class="status[0]"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="point">
          <div class="desc">
            <div class="info" :class="status[1]">报名中</div>
            <div class="icon" :class="status[1]"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="point">
          <div class="desc">
            <div class="info" :class="status[2]">进行中</div>
            <div class="icon" :class="status[2]"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="point">
          <div class="desc">
            <div class="info" :class="status[3]">赛事结束</div>
            <div class="icon" :class="status[3]"></div>
          </div>
        </div>
      </div>
      <div class="my-regulations">
        <!--        <div class="title">-->
        <!--          <div class="icon"></div>-->
        <!--          <span>竞赛规程</span>-->
        <!--        </div>-->
        <div style="padding: 10px 20px 0 20px; width: 100vw; box-sizing: border-box">
          <div v-if="match.accessory" class="file"
            style="display: flex; align-items: center; justify-content: space-between; background-color: #EBF1FE; height: 60px; border-radius: 8px; padding: 0 16px; margin-top: 12px">
            <div style="display: flex; align-items: center">
              <img src="../../assets/downloadImg.png" alt="tp" style="width: 36px; height: 36px; margin-right: 6px">
              <div>{{ match.accessory }}</div>
            </div>
            <van-button size="small" type="info" round style="width: 52px; height: 20px;"
              @click="downLoad">下载</van-button>
          </div>
          <div id="regulations" style="transform-origin: left top;"></div>
        </div>
      </div>
      <div style="height: 80px;"></div>
      <div class="bottom" v-if="!disabled">
        <van-button type="info" block round @click="goProjectList" :disabled="disabled"
          :style="{'background-color':jetlympic? '#00A7FF': '#191919' }" style="border: none;">
          <span style="font-size: 16px; color: #FFFFFF">{{ $t(`match.home.button_text`) }}</span>
        </van-button>
      </div>
    </div>
    <div v-else-if="active === 1">
      <div class="news" v-for="(item, index) in newsList" :key="index" @click="goDetail(item)">
        <div v-if="item.contentType !== 1">
          <div v-if="item.match" class="union-match-info">
            <img class="icon" :src="imageView(item.match.icon)" alt="">
            <div class="name">{{ item.match.chineseName }}</div>
          </div>
          <div class="news-info">
            <div class="left">
              <div class="news-name">
                <span v-if="item.seq > 0">置顶</span>
                <span v-if="item.type === 1">公告</span>
                {{ item.title }}
              </div>
              <div class="tags" v-if="item.tags && item.tags.length > 0">
                <div class="tag" :style="{ 'margin-left': index > 0 ? '5px' : '0' }"
                  v-for="(item, index) in item.tags.split(',')" :key="index">{{ item }}</div>
              </div>
            </div>
            <div class="right">
              <img :src="imageView(item.poster, 90, 68)">
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="item.match" class="union-match-info">
            <img class="icon" :src="imageView(item.match.icon)" alt="">
            <div class="name">{{ item.match.chineseName }}</div>
          </div>
          <video :poster="imageView(item.poster, 180, 108)" :src="originView(item.video)" width="100%" controls
            preload></video>
          <div class="news-info">
            <div class="left">
              <div class="news-name">
                <span v-if="item.seq > 0">置顶</span>
                {{ item.title }}
              </div>
              <div class="tags">
                <div class="tag" :style="{ 'margin-left': index > 0 ? '5px' : '0' }"
                  v-for="(item, index) in item.tags.split(',')" :key="index">{{ item }}</div>
              </div>
            </div>
            <div class="right">
              <img :src="imageView(item.poster, 90, 68)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="active === 3"
      style="background: #FFFFFF; height: 88px; font-size: 16px; color: #333333; text-align: center; line-height: 44px">
      <div v-if="match.showPlayerList === -1">
        组委会暂未开放名单查看功能
      </div>
      <div v-else>
        暂无信息
      </div>
    </div>
    <div v-else-if="active === 5">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="orders" v-if="orderList.length > 0">
          <div class="order" v-for="(item, index) in orderList" :key="index" @click="goOrderDetail(item)">
            <div class="order-title">
              <div style="display: flex; align-items: center">
                <van-image :src="imageView(item.icon)" style="width: 30px; height: 30px;"></van-image>
                <span style="margin-left: 8px">{{ item.teamName }} <span v-if="item.palyerName"> / {{ item.palyerName
                }}</span></span>
              </div>
              <div style="color: red">¥{{ (item.userPayment / 100).toFixed(2) }}</div>
            </div>
            <van-form input-align="right">
              <van-field label="赛事/组别" readonly>
                <template #input>
                  {{ item.matchName }} / {{ item.matchGroup }}
                </template>
              </van-field>
              <van-field label="订单编号" v-model="item.orderId"></van-field>
              <van-field label="创建时间">
                <template #input>
                  {{ getFormatDate(item.createDate, '{y}-{m}-{d} {h}:{i}') }}
                </template>
              </van-field>
              <van-field label="支付状态">
                <template #input>
                  <span v-if="item.orderStatus === 0">待支付</span>
                  <span v-else-if="item.orderStatus === 1">
                    <span v-if="item.refundApplyStatus === 0">发起退款</span>
                    <span v-else-if="item.refundApplyStatus === -1">拒绝退款</span>
                    <span v-else-if="item.refundApplyStatus === 1">退款失败</span>
                    <span v-else-if="item.refundApplyStatus === -2">已支付</span>
                  </span>
                  <span v-else-if="item.orderStatus === 2">
                    <span v-if="item.refundStatus === 4">退款失败</span>
                    <span v-else>退款中</span>
                  </span>
                  <span v-else-if="item.orderStatus === 3">已退款</span>
                  <span v-else-if="item.orderStatus === -1">已取消</span>
                  <span v-else>--</span>
                </template>
              </van-field>
            </van-form>
          </div>
        </div>
        <van-empty v-else description="暂无报名" />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Tab, Tabs, Swipe, SwipeItem, PullRefresh, Empty, Form, Field, Toast } from "vant";
import {
  getBMMatchOrderListByUser,
  getBMUnionMatch,
  getCrmNewsList,
  getUnionSlideList
} from "@/api/match";
import { DateUtil, QNImageUtil } from "@/utils";
Vue.use(VanImage).use(Tab).use(Tabs).use(Swipe).use(SwipeItem).use(Empty).use(PullRefresh).use(Form).use(Field).use(Toast)
import { removeToken } from "@/libs/cookie-storage";
import { getPassport } from "@/libs/passport";
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      match: {},
      place: [],
      unionMatchId: '',
      active: 0,
      status: ['', '', '', ''],
      disabled: true,
      newsList: [],
      carousels: [],
      orderList: [],
      isLoading: false,
      sportType: '',
      clickCount: 0,
      timer: null,
      jetlympic: false,
      isOpenCharge: 0,
      fixedHeaderHeight: 0 // 固定头部元素的高度
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.unionMatchId = this.$route.query.unionMatchId
    if (this.unionMatchId) {
      this.getBMUnionMatch()
    }
    // 获取固定头部元素的高度
    this.updateFixedHeaderHeight()
    // 监听窗口大小变化，重新计算高度
    window.addEventListener('resize', this.updateFixedHeaderHeight)
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.updateFixedHeaderHeight)
  },
  methods: {
    /**
     * 更新固定头部元素的高度
     */
    updateFixedHeaderHeight() {
      this.$nextTick(() => {
        if (this.$refs.fixedHeader) {
          this.fixedHeaderHeight = this.$refs.fixedHeader.offsetHeight
        }
      })
    },
    removeToken() {
      // 增加点击次数  
      this.clickCount++;

      // 清除之前的定时器（如果有）  
      if (this.timer) {
        clearTimeout(this.timer);
      }

      // 设置新的定时器，如果在一定时间内没有新的点击，则重置计数器  
      this.timer = setTimeout(() => {
        this.clickCount = 0;
      }, 1500); // 假设这里设置为1秒，你可以根据需要调整  

      // 检查是否达到了五次点击  
      if (this.clickCount === 5) {
        // 清除定时器，因为我们不再需要它  
        clearTimeout(this.timer);

        // 触发你的事件  
        removeToken()
        Toast('已清除登录状态！')
        // 重置计数器  
        this.clickCount = 0;
      }
    },
    onRefresh() {
      this.getBMMatchOrderListByUser()
    },
    getBMMatchOrderListByUser() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMMatchOrderListByUser(params).then(res => {
        if (res) {
          const data = res.data
          this.orderList = data.list
          this.isLoading = false
        }
      })
    },
    appShare() {
      const shareObj = {
        title: this.match.chineseName + this.getPromotion(this.match.beginDate, this.match.endDate),
        abstract: '邦赛事',
        link: process.env.VUE_APP_BM_MATCH + '#/union-match/match-overall?unionMatchId=' + this.unionMatchId,
        image: this.match.backgroundImage2 ? QNImageUtil.imageView(this.match.icon) : ''
      }
      this.wxShare(shareObj)
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    goUrl(item) {
      if (item.url && /\S+/.test(item.url)) {
        if (/^[http://|https://]\S+/.test(item.url)) window.location.href = item.url
        else window.location.href = 'http://' + item.url
      }
    },
    getUnionSlideList() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getUnionSlideList(params).then(res => {
        if (res) {
          const list = res.data.list || []
          this.carousels.push(...list)
          // 轮播图数据更新后，重新计算固定头部高度
          this.updateFixedHeaderHeight()
        }
      })
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId,
        preview: this.$route.query.preview || 0
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          this.isOpenCharge = data.match.isOpenCharge || 0
          document.title = data.match.chineseName
          if (this.match.province) {
            this.place.push(this.match.province)
          }
          if (this.match.city) {
            this.place.push(this.match.city)
          }
          if (this.match.location) {
            this.place.push(this.match.location)
          }
          const a = new Date().getTime()
          const b = new Date(this.match.endDate).getTime()
          const c = new Date(this.match.regEndDate).getTime()
          const d = new Date(this.match.regBeginDate).getTime()
          const status = []
          if (a >= b) {
            status.push('finish')
            status.push('finish')
            status.push('finish')
            status.push('doing')
            this.disabled = true
          } else if (a > c) {
            status.push('finish')
            status.push('finish')
            status.push('doing')
            status.push('wait')
            this.disabled = true
          } else if (a > d) {
            status.push('finish')
            status.push('doing')
            status.push('wait')
            status.push('wait')
            this.disabled = false
          } else {
            status.push('doing')
            status.push('wait')
            status.push('wait')
            status.push('wait')
            this.disabled = true
          }
          if (!this.match.regBeginDate && !this.match.regEndDate && !this.match.regUpdateEndDate) {
            this.disabled = true
          }
          const regulations = document.getElementById('regulations')
          regulations.innerHTML = this.match && this.match.regulations || ''
          this.status = status
          this.sportType = this.match.sportType || ''
          this.carousels.push({ poster: this.match.backgroundImage2, url: '' })
          this.getUnionSlideList()
          this.getCrmNewsList()
          this.appShare()
          // 数据加载完成后，更新固定头部高度
          this.updateFixedHeaderHeight()
        }
      })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    originView(video) {
      if (!video) return ''
      return QNImageUtil.originView(video)
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    goProjectList() {
      getPassport().then(res => {
        if (res) {
          localStorage.setItem('entry-match', JSON.stringify(this.match))
          this.$router.push('/entry-page/project-list?unionMatchId=' + this.unionMatchId)
        }
      })
    },
    getCrmNewsList() {
      const params = {
        accountId: this.match.accountId,
        unionMatchId: this.unionMatchId,
        pageNum: 1,
        pageSize: 999
      }
      getCrmNewsList(params).then(res => {
        if (res) {
          const { data } = res
          this.newsList = data.list || []
        }
      })
    },
    changeTab() {
      // tab 切换后，重新计算固定头部高度（因为 tabs 可能会显示/隐藏）
      this.updateFixedHeaderHeight()
      
      if (this.active === 0) {
        this.$nextTick(() => {
          const regulations = document.getElementById('regulations')
          regulations.innerHTML = this.match && this.match.regulations || ''
        })
      } else if (this.active === 2) {
        if(this.$route.query.preview) {
            this.$router.push(`/union-match/home?unionMatchId=${this.unionMatchId}&preview=1`)
        } else {
            this.$router.push(`/union-match/home?unionMatchId=${this.unionMatchId}`)
        }
      } else if (this.active === 4) {
        this.$router.push(`/entry-page/entry-list?unionMatchId=${this.unionMatchId}`)
      } else if (this.active === 5) {
        this.getBMMatchOrderListByUser()
      }

    },
    goDetail(item) {
      if (item.contentType === 2) {
        this.handleExternalLink(item.sourceUrl)
      } else {
        this.handleNavigate(`/account/news-detail/${item.id}`)
      }
    },
     handleNavigate(path) {
      console.log(path);
      
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        // 微信小程序环境
        console.log('小程序环境');
        
        const baseUrl = process.env.NODE_ENV === 'development' 
          ? 'https://www.snsports.cn/match-h5-dev/index.html#'
          : 'https://www.snsports.cn/match-h5/index.html#'
        const fullPath = `${baseUrl}${path}`
        wx.miniProgram.navigateTo({
          url: `/pages/webview/index?redirect=${encodeURIComponent(fullPath)}`
        })
      } else {
        console.log('普通环境');
        
        // 普通环境
        this.$router.push(path)
      }
    },
    handleExternalLink(url) {
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/webview/index?redirect=${encodeURIComponent(url)}`
        })
      } else {
        // 普通环境
        window.location.href = /^[http://|https://]/.test(url) ? url : `https://${url}`
      }
    },
    goOrderDetail(item) {
      this.$router.push('/union-match/order-detail/' + item.orderId + '?unionMatchId=' + this.unionMatchId)
    },
    downLoad() {
      window.open(`https://images.snsports.cn/${this.match.accessory}`)
    }
  }
}
</script>

<style lang="scss">
.match-overall {
  background-color: #F6F6F8;
  min-height: 100vh;

  .swipe {
    width: 100vw;
    font-size: 0;
    // height: 56vw;
  }

  .match-info {
    padding: 16px;
    background: #FFFFFF;

    .match-name {
      //overflow:hidden;
      //text-overflow: ellipsis;
      //-webkit-line-clamp: 1;
      //display: -webkit-box;
      //-webkit-box-orient: vertical;
      font-size: 16px;
      line-height: 18px;
      color: #333333;
      padding-bottom: 14px;
    }

    .time-place {
      .row {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .status {
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 36px;
    padding-bottom: 16px;

    .point {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #2463FF;
      position: relative;

      .desc {
        position: absolute;
        top: -27px;
        left: -26px;
        width: 56px;
        font-size: 11px;
        font-weight: 400;
        color: #2760EC;

        .info {
          text-align: center;
          height: 18px;
          line-height: 18px;
          border-radius: 9px
        }

        .icon {
          box-sizing: border-box;
          width: 8px;
          height: 4px;
          border-top-style: solid;
          border-top-width: 4px;
          border-right: 4px #FFFFFF solid;
          border-left: 4px #FFFFFF solid;
          margin: 0 auto;
        }
      }
    }

    .line {
      width: calc(33% - 36px);
      height: 2px;
      background: #2463FF;
      border-radius: 3px;
    }

    .wait {
      color: #86A9FF;
      background: #EBF1FE;
      border-top-color: #EBF1FE;
    }

    .doing {
      color: #FFFFFF;
      background: #2463FF;
      border-top-color: #2463FF;
    }

    .finish {
      color: #2463FF;
      background: #EBF1FE;
      border-top-color: #EBF1FE;
    }
  }

  .my-regulations {
    background: #FFFFFF;
    margin-top: 12px;

    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 25px 0 13px 0;
      margin: 0 16px;
      border-bottom: 0.5px #EEEEEE solid;

      .icon {
        width: 2px;
        height: 12px;
        background-color: #2D60DF;
        margin-right: 6px;
      }
    }

    #regulations {
      padding: 12px 0px;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 16px 12px 12px 8px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .news {
    padding: 16px 12px;
    border-bottom: 1px #F3F3F3 solid;

    .union-match-info {
      display: flex;

      .icon {
        width: 16px;
        height: 16px;
      }

      .name {
        color: #757575;
        font-size: 12px;
        margin-left: 6px;
      }
    }

    .news-info {
      display: flex;
      justify-content: space-between;

      .left {
        width: calc(100vw - 126px);

        .news-name {
          span {
            display: inline-block;
            width: 40px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background-color: #1649F6;
            color: #FFFFFF;
            font-size: 11px;
            border-radius: 2px;
            margin-right: 3px;
          }

          font-size: 16px;
          line-height: 24px;
          color: #282828;
          font-weight: 500;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }

        .tags {
          display: flex;

          .tag {
            padding: 3px 8px;
            color: #1565FC;
            background-color: #EBF2FF;
            font-size: 11px;
          }
        }
      }

      .right {
        img {
          width: 90px;
          height: 68px;
          overflow: hidden;
          border-radius: 4px;
        }
      }
    }
  }

  .orders {
    padding: 16px 16px 20px 16px;

    .order {
      padding-top: 16px;
      margin-bottom: 12px;
      background-color: #FFFFFF;
      border-radius: 4px;
      overflow: hidden;

      .order-title {
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}

.wscnph {
  max-width: 100%;
}
</style>
